import { TFunction } from 'i18next'

import { NameDto } from '../model/NameDto'
import { SortOrder } from './ApiClient'

export const normalizeSortLabel = (
  t: TFunction,
  data: NameDto<string>[],
  labelId?: string | { sort: string; sortOrder: SortOrder }[] | null
): string => {
  if (!labelId || (Array.isArray(labelId) && labelId.length === 0)) {
    return `${t('SortBy')}`
  }
  const labelArray = (Array.isArray(labelId) ? labelId.map(({ sort }) => sort) : [labelId])
    .map((id) => data.find((x) => x.id === id)?.name)
    .filter(Boolean)

  return `${t('SortBy')}: ${labelArray.join(', ')}`
}

export const toSentenceCase = (str?: string | null): string | undefined | null => {
  if (!str) {
    return str
  }
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const snakeToCamel = (fieldName: string): string => {
  return fieldName
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))
}

export const camelToSnake = (fieldName: string): string => {
  return fieldName.replace(/([A-Z])/g, '_$1').toLowerCase()
}
